import React from "react";
import Theme from "../../assets/ui/theme";
import { PositionedBox } from "../../assets/ui";
///////////////////////////////////////////////////////////////////////////////////////////////////

const ModalOverlay = ({
  children,
  open,
  wrapperStyles,
  hideModal,
  ...overlayStyle
}) => (
  <PositionedBox
    top="0"
    left="0"
    zIndex="22"
    width="100%"
    height={open ? "100vh" : "0"}
    overflow="hidden"
    position="fixed"
    transitionDelay={open ? 0 : "0.5s"}
    transform={open ? "translateY(0)" : "translateY(100vh)"}
    {...wrapperStyles}
  >
    <PositionedBox
      top="0"
      left="0"
      width="100%"
      height="100%"
      position="fixed"
      onClick={hideModal}
      bg={Theme.colors.darkBlue08}
      opacity={open ? 1 : 0}
      transition="opacity 0.1s linear"
      transitionDelay={open ? 0 : "0.4s"}
      {...overlayStyle}
    />
    {children}
  </PositionedBox>
);

export default ModalOverlay;
